export * from './common-user-profile-wording.module';
export * from './common-user-profile-wording.pipe';
